import { DOMAIN } from "../consts";

export const getSubscriptionId = (subscription) =>
  subscription?.id ?? subscription?.subscription_id ?? "";

export const getVlessSubscriptionUrl = (subscription) => {
  const subscriptionId = getSubscriptionId(subscription);
  if (!subscriptionId) {
    return "";
  }
  return `${DOMAIN}/subscriptions/${subscriptionId}/vless`;
};
